import { FilterOption } from '#server/models';
import { FilterCheckbox } from '@/components';

interface CheckboxFilterProps {
  title: string;
  options: FilterOption[];
  selectedOptions: string[];
  toggleFilterOption: (title: string, option: string) => void;
}

export const CheckboxFilter = ({ title, options, selectedOptions, toggleFilterOption }: CheckboxFilterProps) => {
  return (
    <>
      {options.map((option) => (
        <div key={option.title} className="mb-4 flex items-start gap-2">
          <FilterCheckbox
            id={`${title}-${option.title}`}
            checked={selectedOptions.includes(option.title)}
            onCheckedChange={() => toggleFilterOption(title, option.title)}
          />
          <label
            htmlFor={`${title}-${option.title}`}
            className="font-proximaNova ml-4 cursor-pointer text-[16px]/[24px] font-normal text-secondary-grey-02"
          >
            {option.title}
          </label>
        </div>
      ))}
    </>
  );
};
